/* eslint-disable react/jsx-no-useless-fragment */
import { Button, Container, Typography } from '@pwskills/rachnaui';
import { useContext, useEffect, useRef, useState } from 'react';
import StyleHtml from '@/HOCs/StyleHtml';
import { ChevronDown, ChevronUp } from '@pwskills/rachnaui/Icons';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { useRouter } from 'next/router';
import { sanitizeDescriptionHtml } from '@/utils/GlobalCommonFunctions';
import ProfessionalThemeHeader from '../Header/ProfessionalThemeHeader';
import Headers from '../Header';

const SEOSection = ({ isAmateur = true }: { isAmateur?: boolean }) => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { seoSection } = courseDetails?.courseMetaDetails || {};
  const [contentHeight, setContentHeight] = useState<number>(0);

  const [showMore, setShowMore] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const maxContentHeight = 400; // Maximum height to show without expanding
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  useEffect(() => {
    if (containerRef.current) {
      const preElements = containerRef.current.querySelectorAll('div > pre');
      preElements.forEach((preElement) => {
        preElement.setAttribute('style', 'word-break: break-word; white-space: break-spaces;');
      });

      setContentHeight(containerRef.current.scrollHeight);
    }
  }, [showMore, seoSection]);

  const returnChildren = () => {
    return (
      <>
        {' '}
        {isAmateur && (
          <header className={isDashboard ? 'flex' : 'flex justify-center text-[#3D3D3D]'}>
            {isDashboard ? (
              <Typography component="h4" variant="semi-bold">
                {seoSection?.heading as string}
              </Typography>
            ) : (
              <Headers
                title={seoSection?.heading as string}
                classes="flex w-full !min-w-full justify-center text-gray-850 medium:w-auto text-center !self-center !w-[50%]  medium:!w-full"
                isSeo
              />
            )}
          </header>
        )}
        {!isAmateur && (
          <>
            {isDashboard ? (
              <Typography component="h4" variant="semi-bold">
                {seoSection?.heading as string}
              </Typography>
            ) : (
              <ProfessionalThemeHeader
                title={seoSection?.heading as string}
                isSeo
                headingClass="text-xl medium:!text-2xl"
              />
            )}
          </>
        )}
        <div
          className={
            isDashboard
              ? 'flex flex-col gap-4'
              : 'bg-blue-50 rounded-lg py-4 px-8 flex flex-col gap-4 !text-gray-850 !font-normal'
          }
        >
          <StyleHtml>
            <div
              ref={containerRef}
              style={{
                wordBreak: 'break-word',
                textJustify: 'auto',
                maxHeight: showMore ? 'none' : `${maxContentHeight}px`,
                overflowY: 'hidden',
                overflowX: 'hidden',
              }}
              dangerouslySetInnerHTML={{
                __html: sanitizeDescriptionHtml(seoSection?.body || ''),
              }}
            />
          </StyleHtml>

          {contentHeight > maxContentHeight && !showMore && (
            <div
              onClick={() => setShowMore(true)}
              className="flex gap-1 items-center self-end cursor-pointer"
            >
              <Button variant="text" className="text-orange-500 !p-0 !text-sm font-bold">
                Read More
              </Button>
              <ChevronDown className="!w-4 !h-4 text-orange-500" />
            </div>
          )}

          {showMore && (
            <div onClick={() => setShowMore(false)} className="flex gap-1 items-center self-end">
              <Button
                variant="text"
                className="text-orange-500 !p-0 !text-sm font-bold self-end cursor-pointer"
              >
                Read Less
                <ChevronUp className="!w-4 !h-4 text-orange-500" />
              </Button>
            </div>
          )}
        </div>
      </>
    );
  };
  return (
    <section className={isDashboard ? '' : '  target:bg-white bg-white '}>
      {isDashboard ? (
        <div className="flex flex-col gap-4">{returnChildren()}</div>
      ) : (
        <Container className="medium:!px-4 large:!px-20 py-9 medium:py-14 flex flex-col !gap-6 large:!gap-8 ">
          {returnChildren()}
        </Container>
      )}
    </section>
  );
};

export default SEOSection;
